webpackJsonp([16],{

/***/ 740:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_show_vue__ = __webpack_require__(783);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_212ed880_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_show_vue__ = __webpack_require__(829);
var normalizeComponent = __webpack_require__(105)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_212ed880_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 783:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_fine_plays__ = __webpack_require__(366);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      finePlay: null,
      myFinePlayHistoryStatus: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    setLinks: 'navigator/setLinks',
    getNumberUnReadApprove: 'masterData/getUnreadFineplayApprove'
  }), {
    fetchData: function fetchData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var loading, res, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading = _this.$loading.show();
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__api_fine_plays__["a" /* default */].show(_this.$route.params.finePlayId);

              case 4:
                res = _context.sent;

                _this.finePlay = res.data.data;
                index = _this.finePlay.fine_play_histories.findIndex(function (n) {
                  return n.recipient_employee_code === _this.$auth.watch.data.employee_code;
                });

                if (index !== -1) _this.myFinePlayHistoryStatus = _this.finePlay.fine_play_histories[index].status;
                loading.hide();
                _context.next = 16;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](1);

                console.error(_context.t0);
                loading.hide();
                _this.$message({ message: 'アクセス権限を持ってありません、!', type: 'error' });

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 11]]);
      }))();
    },
    handleClickApprove: function handleClickApprove() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var loading, res, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                loading = _this2.$loading.show();
                _context2.prev = 1;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__api_fine_plays__["a" /* default */].approve(_this2.finePlay.id);

              case 4:
                res = _context2.sent;

                _this2.finePlay = res.data.data;
                index = _this2.finePlay.fine_play_histories.findIndex(function (n) {
                  return n.recipient_employee_code === _this2.$auth.watch.data.employee_code;
                });

                _this2.myFinePlayHistoryStatus = _this2.finePlay.fine_play_histories[index].status;
                _this2.$message({ message: 'ファインプレーの承認が完了しました!', type: 'success' });
                _this2.getNumberUnReadApprove();
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](1);

                _this2.$message({ message: 'ファインプレーの承認が失敗しました!', type: 'error' });

              case 15:
                loading.hide();

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 12]]);
      }))();
    },
    handleClickDenial: function handleClickDenial() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var loading, res, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                loading = _this3.$loading.show();
                _context3.prev = 1;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__api_fine_plays__["a" /* default */].denial(_this3.finePlay.id);

              case 4:
                res = _context3.sent;

                _this3.finePlay = res.data.data;
                index = _this3.finePlay.fine_play_histories.findIndex(function (n) {
                  return n.recipient_employee_code === _this3.$auth.watch.data.employee_code;
                });

                _this3.myFinePlayHistoryStatus = _this3.finePlay.fine_play_histories[index].status;
                _this3.$message({ message: 'ファインプレーの否認が完了しました!', type: 'success' });
                _this3.getNumberUnReadApprove();
                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3['catch'](1);

                _this3.$message({ message: 'ファインプレーの承認が失敗しました!', type: 'error' });

              case 15:
                loading.hide();

              case 16:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[1, 12]]);
      }))();
    }
  }),
  mounted: function mounted() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this4.fetchData();

            case 2:

              if (_this4.finePlay) {
                _this4.setLinks([{ title: '' + _this4.finePlay.employee.display_name, route: { name: 'finePlayApproves' } }]);
              }

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ 829:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.finePlay)?_c('div',{staticClass:"fine_plays_select_page"},[_c('div',{staticClass:"fine_play_branch"},[_c('span',[_vm._v(_vm._s(_vm.finePlay.institution.official_name_kanji))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.finePlay.presenter_company_code))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.finePlay.presenter_market_code))])]),_vm._v(" "),_c('div',{staticClass:"fine_plays_group_message"},_vm._l((_vm.finePlay.fine_plays),function(message){return _c('div',{staticClass:"fine_play_message_item"},[_c('div',{staticClass:"message_date_name"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(message.display_name))]),_vm._v(" "),_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm._f("dateTimeFormat")(message.message_created_at)))])]),_vm._v(" "),_c('div',{staticClass:"message_content"},[_c('span',{domProps:{"innerHTML":_vm._s(message.content)}})])])}),0),_vm._v(" "),(_vm.myFinePlayHistoryStatus === 'preapproval' && _vm.finePlay.can_approve)?_c('div',{staticClass:"fine_plays_group_button"},[_c('div',{staticClass:"approval",on:{"click":_vm.handleClickApprove}},[_vm._v("承認")]),_vm._v(" "),_c('div',{staticClass:"denial",on:{"click":_vm.handleClickDenial}},[_vm._v("否認")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"sub-header"},[_vm._v("承認履歴")]),_vm._v(" "),_c('div',{staticClass:"fine_play_info"},[_c('div',{staticClass:"employee"},[_c('div',{staticClass:"text"},[_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm._f("dateFormat")(_vm.finePlay.created_at)))]),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(((_vm.finePlay.presenter_company_code) + " " + (_vm.finePlay.employee.name_kanji))))])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"fine_play_histories"},_vm._l((_vm.finePlay.fine_play_histories),function(employee){return _c('div',{staticClass:"employee"},[_c('div',{staticClass:"text"},[_c('span',{staticClass:"date",class:{'show': employee.status !== 'preapproval'}},[_vm._v(_vm._s(_vm._f("dateFormat")(employee.created_at)))]),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(((employee.recipient_company_code) + " " + (employee.recipient.name_kanji))))])]),_vm._v(" "),_c('div',{staticClass:"status"},[(employee.status !== 'preapproval')?_c('span',{class:{'approval': employee.status === 'approval', 'denial': employee.status === 'denial'}},[_vm._v(_vm._s(employee.status === 'approval' ? '承認済' : '否認'))]):_vm._e()])])}),0)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status"},[_c('span',[_vm._v("申請者")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/16.1b9957e78113450d73d5.js